import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useKioskBasePath } from '../hooks/useKioskBasePath';

export const KioskSignup: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tmQuery = searchParams.get('testmode') === 'true' ? '?testmode=true' : '';
  const basePath = useKioskBasePath();

  useEffect(() => {
    navigate(`/${basePath}/${slug}${tmQuery}`, { replace: true });
  }, [slug, navigate, basePath, tmQuery]);

  return null;
};

export default KioskSignup;
